import { Injectable } from '@angular/core';
import { Article } from '@article/const';
import { ArticlesSearchService } from '@article/data-access';
import { RouterState, RoutingService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ArticleService {
  constructor(
    private articlesSearchService: ArticlesSearchService,
    private routingService: RoutingService,
  ) {}

  getCurrentArticleCode(): Observable<string | undefined> {
    return this.routingService.getRouterState().pipe(
      map((state: RouterState) =>
        state.state.semanticRoute === 'articleDetail' ? state.state.params['code'] : undefined,
      ),
      distinctUntilChanged(),
    );
  }

  getCurrentArticle(): Observable<Article | undefined> {
    return this.getCurrentArticleCode().pipe(
      switchMap((code) => {
        if (code) {
          return this.getArticleByCode(code);
        }

        return of(undefined);
      }),
    );
  }

  getArticleByCode(code: string): Observable<Article | undefined> {
    return this.articlesSearchService.getArticleState(code).pipe(
      tap((state) => {
        if (!state.loading && !state.error && !state.success) {
          this.articlesSearchService.loadArticle(code);
        }
      }),
      filter((state) => Boolean(!state.loading && (state.error || state.success))),
      map((state) => state.value),
    );
  }

  loadCurrentArticle(): void {
    this.getCurrentArticleCode()
      .pipe(take(1))
      .subscribe((code) => {
        if (code) {
          this.articlesSearchService.loadArticle(code);
        }
      });
  }

  saveRating(code: string, rating: number): void {
    this.articlesSearchService.saveRating(code, rating);
  }
}
